const FULLSCREEN_APIS = [
    // http://dvcs.w3.org/hg/fullscreen/raw-file/tip/Overview.html
    {
        enabled: 'fullscreenEnabled',
        element: 'fullscreenElement',
        request: 'requestFullscreen',
        exit: 'exitFullscreen',
        events: {
            change: 'fullscreenchange',
            error: 'fullscreenerror',
        },
    },
    {
        enabled: 'webkitFullscreenEnabled',
        element: 'webkitCurrentFullScreenElement',
        request: 'webkitRequestFullscreen',
        exit: 'webkitExitFullscreen',
        events: {
            change: 'webkitfullscreenchange',
            error: 'webkitfullscreenerror',
        },
    },
    {
        enabled: 'mozFullScreenEnabled',
        element: 'mozFullScreenElement',
        request: 'mozRequestFullScreen',
        exit: 'mozCancelFullScreen',
        events: {
            change: 'mozfullscreenchange',
            error: 'mozfullscreenerror',
        },
    },
    {
        enabled: 'msFullscreenEnabled',
        element: 'msFullscreenElement',
        request: 'msRequestFullscreen',
        exit: 'msExitFullscreen',
        events: {
            change: 'MSFullscreenChange',
            error: 'MSFullscreenError',
        },
    },
] as const;

export function requestFullscreen(element: Element) {
    const prefix = getVendorPrefixes();

    if (!prefix) {
        // Unsupported platform
        return;
    }

    return element[prefix.request]();
}

export function exitFullscreen() {
    const prefix = getVendorPrefixes();

    if (!prefix) {
        // Unsupported platform
        return;
    }

    return document[prefix.exit]();
}

export function isFullscreenEnabled() {
    const prefix = getVendorPrefixes();

    if (!prefix) {
        // Unsupported platform
        return;
    }

    return document[prefix.enabled];
}

export function getFullscreenElement() {
    const prefix = getVendorPrefixes();

    if (!prefix) {
        // Unsupported platform
        return;
    }

    return document[prefix.element];
}

let CACHED_API: null | typeof FULLSCREEN_APIS[0] | undefined = null;

export function getVendorPrefixes() {
    if (CACHED_API === null) {
        // Cast to W3
        CACHED_API = FULLSCREEN_APIS.find((api) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (document as any)[api.exit];
        }) as typeof FULLSCREEN_APIS[0] | undefined;
    }

    return CACHED_API;
}
